import {
  ResponsiveContainer,
} from "recharts";

export default function ExecutiveChartCard({
  title,
  subtitle,
  height = 340,
  children,
}) {

  return (
    <section className="bg-white border border-slate-200 rounded-2xl p-6 shadow-sm">

      <div className="mb-5">
        <h3 className="text-lg font-semibold text-slate-900">
          {title}
        </h3>

        {subtitle && (
          <p className="mt-1 text-sm text-slate-500">
            {subtitle}
          </p>
        )}
      </div>

      <div style={{ height }}>
        <ResponsiveContainer width="100%" height="100%">
          {children}
        </ResponsiveContainer>
      </div>

    </section>
  );
}